<style lang="less" scoped>
    @import "../css/common.less";
    @label_width: 150px;
    .title{
        padding: 0 25px;
    }
    .content{
        margin-top: 10px;
    }
    .value img{
        max-width: 100%;
    }
    .stock-dosage-table{
        th{
            padding: 5px 2px;
            line-height: 1;
        }
        td{
            padding: 5px 2px;
            line-height: 1;
            white-space: nowrap;
        }
    }
</style>
<template>
  <div class="wrap">
    <h2 class="title">
      存货详情
    </h2>
    <div
      v-if="stock.id"
      class="content"
    >
      <Row>
        <!-- <i-col span="12">
          <div class="line">
            <div class="label">
              为组合存货
            </div>
            <div class="value">
              {{ stock.is_assemble ?'是': '否' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              为赠品
            </div>
            <div class="value">
              {{ stock.is_gift ?'是': '否' }}
            </div>
          </div>
        </i-col> -->
        <!-- drop_shipping -->
        <i-col span="12">
          <div class="line">
            <div class="label">
              是否一件代发
            </div>
            <div class="value">
              {{ stock.drop_shipping ?'是': '否' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="is_store||is_agreement"
          span="12"
        >
          <div class="line">
            <div class="label">
              自动调节库存
            </div>
            <div class="value">
              {{ stock.auto_balance ?'是': '否' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.drop_shipping"
          span="12"
        >
          <div class="line">
            <div class="label">
              一件代发供应商
            </div>
            <div class="value">
              {{ stock.payee_company_name }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.drop_shipping"
          span="12"
        >
          <div class="line">
            <div class="label">
              收货信息
            </div>
            <div class="value">
              {{ stock.payee_company_conctract_address }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.drop_shipping"
          span="12"
        >
          <div class="line">
            <div class="label">
              一件代发成本单价
            </div>
            <div class="value">
              {{ $util.formatPrice(stock.cost_unit_price) }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              申请人
            </div>
            <div class="value">
              <CustomerPoptip
                v-if="stock.apply_user_id"
                :customer_id="stock.apply_user_id"
              >
                <span class="link">{{ stock.apply_user }}</span>
              </CustomerPoptip>
              <span v-else>-</span>
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              所属团队
            </div>
            <div class="value">
              {{ teamName('team_id') }}
            </div>
          </div>
        </i-col>
        <!-- <i-col
          v-if="is_agreement"
          span="12"
        >
          <div class="line">
            <div class="label">
              使用团队
            </div>
            <div class="value">
              {{ teamName('use_team_id') }}
            </div>
          </div>
        </i-col> -->
        <i-col
          v-if="is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              产品分类
            </div>
            <div class="value">
              {{ group_name }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              电商目录
            </div>
            <div class="value">
              {{ stock.product_type_name || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              产品名称
            </div>
            <div class="value">
              {{ stock.name || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              单位
            </div>
            <div class="value">
              {{ stock.stock_unit_name || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              SPU
            </div>
            <div class="value">
              {{ stock.cya_spu ? (stock.cya_spu.spu_name || '-') : '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              是否进口
            </div>
            <div class="value">
              <span v-if="stock.imported===true">
                是
              </span>
              <span v-else-if="stock.imported===false">
                否
              </span>
              <span v-else>
                -
              </span>
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              规格型号
            </div>
            <div class="value">
              {{ stock.spec || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              备注
            </div>
            <div class="value">
              {{ stock.desc || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              ISBN
            </div>
            <div class="value">
              {{ stock.isbn || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              69码
            </div>
            <div class="value">
              {{ stock.barcode || '-' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.is_assemble"
          span="24"
        >
          <div
            class="line"
          >
            <div class="label">
              组合存货用量
            </div>
            <div class="value">
              <table class="mis-table stock-dosage-table">
                <tr>
                  <th width="80">
                    存货编码
                  </th>
                  <th>存货名称</th>
                  <th>团队</th>
                  <th>用量</th>
                  <th>备注</th>
                </tr>
                <tr
                  v-for="(stock_dosage, index) in stock.stock_dosages"
                  :key="stock_dosage.id"
                >
                  <td>{{ stock_dosage.stock_uid || '-' }}</td>
                  <td>{{ stock_dosage.stock_name || '-' }}</td>
                  <td>
                    <TeamName :id="stock_dosage.team_id" />
                  </td>
                  <td>{{ stock_dosage.qty }}</td>
                  <td>{{ stock_dosage.remark }}</td>
                </tr>
              </table>
            </div>
          </div>
        </i-col>
        <i-col
          v-if="is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              所属公司
            </div>
            <div class="value">
              {{ company_name }}
            </div>
          </div>
        </i-col>
        <i-col span="12">
          <div class="line">
            <div class="label">
              内部编码
            </div>
            <div class="value">
              <div v-if="stock.internal_code">
                {{ stock.internal_code || '' }}
              </div>
              <div v-else-if="stock.tax_code">
                {{ stock.uid || '' }}-{{ stock.tax_code.code || '' }}
              </div>
              <span v-else>-</span>
            </div>
          </div>
        </i-col>
        <!-- <i-col span="12">
          <div class="line">
            <div class="label">
              开票信息
            </div>
            <div class="value">
              <div v-if="stock.tax_code">
                {{ stock.tax_code.code }}-{{ stock.tax_code.name }}
              </div>
              <span v-else>-</span>
            </div>
          </div>
        </i-col> -->
        <i-col
          v-if="is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              存货编码
            </div>
            <div class="value">
              {{ stock.uid || '-' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.id && is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              是否作废存货
            </div>
            <div class="value">
              {{ stock.del ?'是':'否' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.del "
          span="12"
        >
          <div class="line">
            <div class="label">
              废弃原因
            </div>
            <div class="value">
              {{ stock.del_reason }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              是否委外
            </div>
            <div class="value">
              {{ stock.outsourcing?'是':'否' }}
            </div>
          </div>
        </i-col>
        <i-col
          v-if="stock.outsourcing&&is_financer_stock"
          span="12"
        >
          <div class="line">
            <div class="label">
              委外关系
            </div>
            <div class="value">
              {{ stock.outsource_relation }}
            </div>
          </div>
        </i-col>
        <!--  v-if="edit_stock.id && is_financer_stock" -->
        <!--   <div class="line">
        <div class="label">
          是否委外
        </div>
        <div class="value">
          {{ stock.outsourcing?'是':'否' }}
        </div>
      </div>
      <div
        v-if="stock.outsourcing"
        class="line"
      >
        <div class="label">
          委外关系
        </div>
        <div class="value">
          {{ stock.outsource_relation }}
        </div>
      </div> -->
      </Row>
      <Row />
      <Row>
        <!-- <i-col span="12">
          <div class="line">
            <div class="label">
              英文名
            </div>
            <div class="value">
              {{ stock.name_en || '-' }}
            </div>
          </div>
        </i-col> -->
      </Row>
      <Row>
        <!-- stock_unit_name -->
      </Row>
      <Row>
        <!-- <i-col span="12">
          <div class="line">
            <div class="label">
              关键字
            </div>
            <div class="value">
              {{ stock.keyword || '-' }}
            </div>
          </div>
        </i-col> -->
      </Row>
      <Row />
      <!-- <Row>
        <i-col span="12">
          <div class="line">
            <div class="label">
              上市时间
            </div>
            <div class="value">
              {{ stock.launch_date || '-' }}
            </div>
          </div>
        </i-col>
        <i-col span="12" />
      </Row> -->
      <!--<div class="line">-->
      <!--<div class="label">品牌</div>-->
      <!--<div class="value">{{stock.brand || '-'}}</div>-->
      <!--</div>-->
      <Divider />
      <div class="line">
        <StockOutChart :stock_id="stock.id" />
      </div>
      <div class="line">
        <StockInventoryChart :stock_id="stock.id" />
      </div>
      <div class="line">
        <StockContract
          :stock_id="stock.id"
          size="small"
        />
      </div>
    
      <!-- <div class="line">
        <div class="label">
          条码图片
        </div>
        <div class="value">
          <img
            v-if="stock.barcode_img"
            :src="fileUrl(stock.barcode_img)"
          >
          <span v-else>-</span>
        </div>
      </div> -->
      <!-- <div class="line">
        <div class="label">
          产品图片
        </div>
        <div class="value">
          <img
            v-if="stock.stock_img"
            :src="fileUrl(stock.stock_img)"
          >
          <span v-else>-</span>
        </div>
      </div> -->
      <div
        v-if="stock.user_flow"
        class="line user-flow"
      >
        <div class="label">
          流程状态
        </div>
        <div class="value">
          <UserFlow :user_flow="stock.user_flow" />
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="text-center"
    >
      <Spin
        size="large"
        fix
      />
    </div>
  </div>
</template>
<script>
  import ViewerItem from '../item';
  import TeamName from '../../../team/components/name';
  // import StockArrived from '../../../stock/components/stock_arrived';
  import StockContract from '../../../stock/components/stock_contract';
  import StockOutChart from '../../../stock/components/stock_out_chart';
  import StockInventoryChart from '../../../stock/components/stock_inventory_chart';
  import StockUtil from '../../../stock/libs/util';
  import stockMixIn from '@/views/stock/mixins/stock.js'
  import {mapGetters} from "vuex";
  import { util_api } from '@/libs/util_api'
  const { query_payee_company_withid } = util_api
  export default {
    components: { ViewerItem, TeamName, StockContract, StockOutChart, StockInventoryChart },
    mixins: [stockMixIn],
    props: {
      model_id: {
        type: Number
      }
    },
    data() {
      return {
        stock: {},
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        teams_hash: 'async/root_teams_hash',
      }),
      company_name() {
        let company = '';
        switch (this.stock.company_code) {
        case 'CYA':
          company = "超有爱";
          break;
        case 'LS':
          company = "良师益友";
          break;
        case 'ZS':
          company = "终身成长";
          break;
        default:
          company = "-";
        }
        return company;
      },
      group_name() {
        return StockUtil.getGroupName(this.stock.group) || '-';
      }
    },
    created() {
      this.getStock();
    },
    mounted() {
      //
    },
    methods: {
      getStockUnits(stock) {
       
        StockUtil.getStockUnits().then(({stock_units = []} = {}) => {
          stock_units = stock_units || []
          stock_units.forEach(item => {
            if (stock.stock_unit_id === item.id) {
              this.$set(this.stock, 'stock_unit_name', item.name)
            }
          })
        })
      },
      teamName(key) {
        const id = this.stock[key]
        const team = this.teams_hash[id];
        return team ? team.name : '-';
      },
      getDropShipping(stock) {
        if (stock.payee_company_id) {
          this.$http.get(query_payee_company_withid, {
            id: stock.payee_company_id
          }).then(res => {
            res = res && res[0]
           
            if (res) {
              this.$set(this.stock, 'payee_company_name', res.name)
            }
            if (res && res.payee_company_contacts) {
              res.payee_company_contacts.forEach(item => {
                if (stock.payee_company_contact_id === item.id) {
                  this.$set(this.stock, 'payee_company_conctract_address', item.address)
                }
              })
            }
            // payee_company_contact_id
            //stock.payee_company_name
           
          })

        }
      },
      getStock() {
        this.loading = true;
        Util.ajax.get(Util.api.stock_detail, {
          params: {
            id: this.model_id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.getDropShipping(res.data.stock)
            this.getStockUnits(res.data.stock)
            this.stock = res.data.stock;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      formatDecimal(num) {
        return Util.formatDecimal(num);
      },
      fileUrl(filepath) {
        return Util.publicOSSUrl(filepath) + '?x-oss-process=style/preview';
      }
    }
  }
</script>
